// extracted by mini-css-extract-plugin
export var contrastLow = "_3n-1";
export var externalLink = "_3n-2";
export var externalLinkIcon = "_3n-3";
export var link = "_3n-0";
export var linkLabel = "_3n-4";